module.exports = __webpack_public_path__ + "img/1 (141).092399b8.png";